import { FaArrowRight } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { allImagesPath } from "../../../lib/constants/ConstantsData";
import { Cards } from "../../../components/Card";
import { Link, useNavigate } from "react-router-dom";
import { useProducts } from "../../../hooks/useProducts";
import { Product } from "../../../models/product";
import "swiper/css";
import "swiper/css/navigation";

const ProductsSection = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError } = useProducts();
  const products = (data?.data?.products || []).slice(0, 10); // Only take first 10 products

  const toAboutUs = () => {
    navigate("about-us");
  };

  if (isLoading) {
    return (
      <div className="container mx-auto flex w-[90%] items-center justify-center py-8 sm:max-w-xl sm:py-12 md:max-w-[700px] md:py-16 lg:max-w-4xl lg:py-20 xl:max-w-6xl 2xl:max-w-7xl">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black"></div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="container mx-auto flex w-[90%] items-center justify-center py-8 text-red-500 sm:max-w-xl sm:py-12 md:max-w-[700px] md:py-16 lg:max-w-4xl lg:py-20 xl:max-w-6xl 2xl:max-w-7xl">
        Error loading products
      </div>
    );
  }

  return (
    <>
      <div className="container mx-auto flex w-[90%] flex-col py-8 sm:max-w-xl sm:py-12 md:py-16 md:max-w-6xl lg:py-20 xl:max-w-6xl 2xl:max-w-7xl">
        <div className="mb-6 flex flex-col items-center justify-between gap-4 sm:flex-row sm:gap-0">
          <h1 className="text-center font-heading text-2xl uppercase sm:text-3xl md:text-4xl lg:text-5xl">
            Find the right parts for You
          </h1>
          <Link
            to="products"
            className="flex items-center gap-2 font-sfPro text-base font-medium text-black transition hover:text-gray-600 sm:text-lg"
          >
            View All <FaArrowRight />
          </Link>
        </div>

        {/* Swiper Carousel */}
        <div className="mb-8 sm:mb-12 md:mb-16 ">
          <div className="relative">
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              slidesPerView={1}
              loop={true}
              navigation={{
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              }}
              breakpoints={{
                320: { slidesPerView: 1, spaceBetween: 10 },
                640: { slidesPerView: 2, spaceBetween: 15 },
                1024: { slidesPerView: 3, spaceBetween: 20 },
                1280: { slidesPerView: 4, spaceBetween: 20 },
              }}
            >
              {products.map((product: Product) => (
                <SwiperSlide key={product.id}>
                  <Cards data={product} />
                </SwiperSlide>
              ))}
              {/* View All Button Slide */}
              {/* <SwiperSlide className=" flex items-center justify-center"> */}
              {/* <div className="flex h-[20px] sm:h-full w-full items-center justify-center">
                  <Link
                    to="products"
                    className="flex h-full w-full flex-col items-center justify-center gap-4 rounded-lg border-2 border-black p-8 text-center transition-all hover:bg-black hover:text-white"
                  >
                    <span className="text-2xl font-semibold">View All Products</span>
                    <FaArrowRight className="h-6 w-6" />
                  </Link>
                </div> */}
              {/* </SwiperSlide> */}
            </Swiper>
            {/* Custom Navigation Buttons */}
            <div className="swiper-button-prev !w-12 !h-12 !bg-white !rounded-full !shadow-lg after:!text-black after:!text-xl"></div>
            <div className="swiper-button-next !w-12 !h-12 !bg-white !rounded-full !shadow-lg after:!text-black after:!text-xl"></div>
          </div>
        </div>

        <div className=" mt-12 flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-12">
          <div className="  my-2 flex h-[350px] w-[98%] items-center justify-center lg:h-[700px]  lg:w-[50%]">
            {/* <video
              className="h-full w-full rounded-md object-cover md:w-[98%] lg:h-[100%] lg:w-[100%]"
              controls
            >
              <source src={allImagesPath.storyVideo} type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}

            <img src={allImagesPath.homeOrderSection} className="h-full w-full rounded-md object-cover md:w-[98%] lg:h-[100%] lg:w-[100%]"
            />

          </div>

          <div className="text-content mt-[20px] -mb-24 lg:mb-0 flex flex-col items-center justify-center p-2 lg:flex lg:w-[50%] lg:items-start lg:justify-start lg:text-left">
            {/* <h2 className="mx-auto max-w-3xl font-heading text-2xl font-normal uppercase leading-[40px] tracking-normal text-black sm:text-3xl md:text-4xl lg:text-5xl">
              CRAFTING QUALITY, ONE CUSTOM ORDER AT A TIME
            </h2> */}
            <h1 className="font-heading font-light lg:text-[50px] md:text-[36px] sm:text-[30px] text-[24px] leading-[1.2] text-black">
              CRAFTING QUALITY, ONE ENCLOSURE AT A TIME
            </h1>

            <p className="mt-6 font-sfPro text-justify text-sm text-paragraph sm:text-base lg:text-md xl:text-lg  lg:text-left">
              At Obscura we are passionate about delivering high-quality accurate enclosures. With years of
              experience, we specialize in precision manufacturing. We ensure that every piece meets the
              highest standards. Whether you need enclosures, pickguards, knobs, or custom powder coat
              finishes, we bring your ideas to life with craftsmanship and care.   <br />
              <br /> What started as a small workshop has now grown into a trusted brand for custom
              manufacturing. We take pride in offering high-quality services like CNC Machining, Powder
              Coating, and UV Printing. Our mission is simple: provide our customers with custom products
              that exceed expectations.
            </p>
            <button
              onClick={toAboutUs}
              className="mt-8 h-12 w-48 font-sfPro rounded-full bg-black px-6 py-2 text-sm font-medium text-white transition-all duration-300 hover:scale-105 hover:shadow-lg sm:h-14 sm:w-56 sm:text-base"
            >
              Learn More About Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsSection;
